// tyrant-throne.midokuni.com
import IStyle from "Interfaces/IStyle";
import React, { useEffect, useMemo, useState } from "react";
import { Form, Image, Row } from "react-bootstrap";
import { getJson } from "Utils/Common";
import { IStellaSoraCharacter, StellaSoraCharacter } from "Views/StellaSora/Models";
import PotentialCard from "Views/StellaSora/PotentialCard";

const styles:IStyle = {
	cardContainer: {
		display: "flex", 
		flexDirection: "row", 
		flexWrap: "wrap"
	},
}

export default function Pots() {
	const DATA_URL = 'https://raw.githubusercontent.com/AutumnVN/StellaSoraData/refs/heads/main/character.json';
	const [characters, setCharacters] = useState<StellaSoraCharacter[]>([]);
	const [search, setSearch] = useState<string>("");
	const [level, setLevel] = useState<number>(6);
	useEffect(() => {
		async function fetchData() {
			const charaTask = getJson(DATA_URL);
			const charas = Object.values(await charaTask).map(chara=>new StellaSoraCharacter(chara as IStellaSoraCharacter));
			charas.sort((a,b)=>a.name.localeCompare(b.name));
			setCharacters(charas);
		}
		fetchData();
	},[]);
	const display = useMemo(() => {
		if (search.trim() === "") return characters;
		return characters.filter(c=>c.name.toLowerCase().includes(search.toLowerCase()));
	}, [characters, search])
	return (<>
	<h3 className="text-pink">Tyrant Throne - Potentials</h3>
	<div style={{maxWidth: "min(90vw, 400px)", marginBottom: 10}}>
		<div><label>Trekker</label><input id="search" value={search} className="search" style={{width:"100%"}} type="text" onChange={(e)=>setSearch(e.target.value.replaceAll("/",""))}></input></div>
		<div><label>Potential Level</label><input id="level-text" type="number" value={level} onChange={(e)=>{setLevel(parseInt(e.target.value))}} step={1} min={1} max={100}></input>
		<Form.Range id="level-slide" value={level} onChange={(e)=>{setLevel(parseInt(e.target.value))}} min={1} step={1} max={13}></Form.Range></div>
	</div>
	{display.map((chara)=>(<div key={chara.id}>
		<div style={styles.cardContainer}>
			<div style={{display: "inline-block",margin: 10}}>
			<h1 className="text-pink"><Image src={chara.getIcon()} style={{width: 100}} />{chara.name} Main</h1>
			{chara.getPotentials(true).map(pots => {
				return (<div style={styles.cardContainer}>
					{pots.map(pot => <PotentialCard pot={pot} level={level} key={pot.id} />)}
				</div>)
			})}</div>
			<div style={{display: "inline-block",margin: 10}}>
			<h1 className="text-pink"><Image src={chara.getIcon()} style={{width: 100}} />{chara.name} Support</h1>
			{chara.getPotentials(false).map(pots => {
				return (<div style={styles.cardContainer}>
					{pots.map(pot => <PotentialCard pot={pot} level={level} key={pot.id} />)}
				</div>)
			})}</div>
		</div>
	</div>))}
	<Row className="responsive-font"><p>The data used here is processed from <a href="https://stelladb.pages.dev">StellaDB</a></p></Row>
	<Row className="responsive-font"><p>I'm lazy to set up another webpage for SS. For now I'm putting it here.</p></Row>
	</>);
}